import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlipHorizontal";
const FlipHorizontal = memo(themed(Icon));
export {
  FlipHorizontal
};
//# sourceMappingURL=flip-horizontal.js.map
